import { MyProfileNotificationsPage } from '@/components/MyProfileNotificationsPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MyProfileNotificationsPage, {
  requiresEvery: [RouteRestrictions.AUTHENTICATION],
});
